import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type UserAnswerEntityTableName = 'user_answers';

export type PreparedUserAnswerData = {
    record: Model;
    table: UserAnswerEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: UserAnswerEntityTableName,
    operation: ValidationOperation,
): PreparedUserAnswerData => ({
    record,
    table,
    operation,
});

export const mapRecords = (
    records: Model[],
    table: UserAnswerEntityTableName,
    operation: ValidationOperation,
): PreparedUserAnswerData[] =>
    records.map((record) => mapRecord(record, table, operation));

export const addPreparedDataBatch = async (
    preparedData: PreparedUserAnswerData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
